import { RouteLocationNormalized, START_LOCATION } from 'vue-router';
import _ from 'lodash';
import { sendSegmentPageview } from '../../lib/segment';

const segmentPageviews = (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  try {
    const componentTitle = (to.matched[0]?.components?.default as { name?: string })?.name;
    const processedName = _.startCase(_.replace((to.name as string) || '', /-/g, ' ')) || 'Unknown Page';

    const pageProperties: {
      title?: string;
      url: string;
      path: string;
      search?: string;
      referrer?: string;
    } = {
      title: componentTitle,
      url: document.location.href,
      path: document.location.pathname,
      search: document.location.search || undefined,
    };

    // START_LOCATION means this is the entry pageview, where the visitor arrived from
    // outside the app. Sending any referrer here would override the external one
    // analytics.js reads off document.referrer, so leave the key off entirely.
    if (from !== START_LOCATION && from.fullPath) {
      pageProperties.referrer = document.location.origin + from.fullPath;
    }

    sendSegmentPageview(`Sittercity-Web: ${processedName}`, pageProperties);
  } catch (error) {
    console.error('Segment tracking failed:', error);
  }
};

export default segmentPageviews;
